// Libraries
import { VictoryStyleInterface } from 'victory';
// Types
import { RatingKeys } from '@globalTypes/index';
// Utils
import { colors } from '@theme/foundations';
import { RatingList } from '@utils/constants';

/**
 * Represents the point scatter variations for the PointScatter component.
 *
 * @function
 * @param {number} strokeWidth - The stroke width for the points.
 * @param {string} fill - The fill color for the points.
 * @returns {object} - The point scatter variations object.
 */
export const generatePointScatterVariations = (strokeWidth: number, fill: string) => {
  const pointScatterVariations: Partial<Record<RatingKeys, VictoryStyleInterface>> = {};

  RatingList.forEach((key) => {
    pointScatterVariations[key] = {
      data: {
        stroke: colors.ratings[key].dark,
        fill,
        strokeWidth,
      },
    };
  });

  return pointScatterVariations;
};
